var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-overlay',{attrs:{"value":_vm.isLoading()}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"100"}})],1),_c('v-card-text',[_c('list-user')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }